import { BsGlobe, BsHeadset, BsRobot, BsGraphUpArrow } from "react-icons/bs";

function Stats() {
  const stats = [
    {
      icon: <BsGlobe />,
      number: "50+",
      title: "Projects Delivered",
    },
    {
      icon: <BsGraphUpArrow />,
      number: "100%",
      title: "Client Commitment",
    },
    {
      icon: <BsHeadset />,
      number: "24/7",
      title: "Support",
    },
    {
      icon: <BsRobot />,
      number: "3+",
      title: "Core Services",
    },
  ];

  return (
    <section className="stats-section">
      <div className="container">
        <div className="section-title mb-5">
          <h2>Helping Businesses Grow Through Technology</h2>
        </div>

        <div className="row g-4">
          {stats.map((item, index) => (
            <div className="col-lg-3 col-md-6" key={index}>
              <div className="stat-card">
                <div className="stat-icon">{item.icon}</div>

                <h2>{item.number}</h2>

                <p>{item.title}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Stats;
